module.exports = __webpack_public_path__ + "img/8003.c35e8d9d.gif";